import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';

import { DynamicListModel } from '../shared/model/dynamic-list.model';
import { ReturnMessageModel } from '../shared/model/return-message.model';
import { DynamicListService } from '../shared/service/dynamic-list.service';
import { MessageComponent } from '../shared/component/message/message.component';
import { ListValueModalComponent } from '../shared/component/list-value-modal/list-value-modal.component';

@Component({
  styles: [''],
  selector: 'app-dynamic-list',
  templateUrl: './dynamic-list.component.html',
})
export class DynamicListComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ListValueModalComponent) modal: ListValueModalComponent;

  lastEvent: any;
  totalRecords: number;

  primaryOptions: any[] = [];

  listOptions: any[] = [];
  lists: DynamicListModel[] = [];
  list: DynamicListModel = new DynamicListModel();
  listAndFields: DynamicListModel = new DynamicListModel();

  selectedField: any = {};

  selectedMethod = '';
  selectedOrdenation = '';

  ascDesc = [];
  ordenation = [];

  constructor(private translateService: TranslateService, private listService: DynamicListService) {}

  ngOnInit() {}

  lazy(e) {
    this.lastEvent = e;

    this.listService.getPaginated({ init: e.first, end: e.rows })
    .subscribe((lists) => {
      if (lists) {
        const { rows, count } = lists;

        this.totalRecords = count as number;
        this.lists = rows as DynamicListModel[];

        if (rows && rows.length) {
          this.listOptions = rows.map(({ name: label, id: value }) => { return { label, value }})
        }
      } else return this.message.error(this.translate('error'))

      this.loadOrdenation();
    });
  }

  loadAllFields() {
    if (this.list && this.list.id)
    this.listService.findByPk(this.list.id + '').subscribe((list) => {
      this.listAndFields = new DynamicListModel(list);
  
      const { dyn_list_field_raw: raw, dyn_list_field_options: options } = list;

      if (options && options.length) options.forEach((v) => {
        this.listAndFields.fields.push(v)
      });
  
      if (raw && raw.length) raw.forEach((v) => {
        this.listAndFields.fields.push(v);

        if (v.primary) {
          this.listAndFields.primary_id = v.id;
        }
      });

      this.loadPrimarySelectByFieldRaws(raw);
      // this.loadPrimarySelectByAllTypes();
    });
  }

  existFields = () => this.listAndFields.fields && this.listAndFields.fields.length;

  loadPrimarySelectByFieldRaws(raws) {
    if (raws && raws.length) {
      this.primaryOptions = raws.map(
        ({ id: value, name: label }) => {
        return { label, value }
      });
    } else this.primaryOptions = [];
  }

  loadPrimarySelectByAllTypes() {
    if (this.existFields()) {
      this.primaryOptions = this.listAndFields.fields.map(
        ({ id: value, name: label }) => {
        return { label, value }
      });
    } else this.primaryOptions = [];
  }

  onSelectField(e) {
    this.selectedField = e.data;
  }

  onSelectList(e) {
    this.list = e.data as DynamicListModel;

    this.loadAllFields();
    this.onNewField();
  }

  onSelectPrimary({ value }) {
    if (this.existFields()) {
      const { primary_id, fields } = this.listAndFields;

      const newIndex = fields.findIndex(({ id }) => value == id);
      const oldIndex = fields.findIndex(({ primary }) => primary);

      if (newIndex < 0) return this.message.error('need_be_field_raw');

      if (newIndex > -1) this.listAndFields.fields[newIndex].primary = true;
      if (oldIndex > -1) this.listAndFields.fields[oldIndex].primary = false;

      if (oldIndex < 0 || !primary_id) 
      return this.listService.saveField(this.listAndFields.fields[newIndex])
      .pipe(take(1)).subscribe((r: ReturnMessageModel) => {
        this._responseErrorHandler(r);
      });

      this.listService.saveField(this.listAndFields.fields[oldIndex]).pipe(take(1)).subscribe(_ => {
        this.listService.saveField(this.listAndFields.fields[newIndex])
        .pipe(take(1)).subscribe((r: ReturnMessageModel) => {
          this._responseErrorHandler(r);
        })
      });
    }
  }

  onSaveList() {
    this.listService.saveList(this.list).subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewList();
    });
  }

  onSaveField() {
    if (!this.list.id) return this.message.error(this.translate('list_not_selected'))

    this.selectedField.dyn_list_id = this.list.id;

    this.listService.saveField(this.selectedField).subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.loadAllFields();
      this.onNewField();
    });
  }

  onNewList() {
    this.list = new DynamicListModel();

    this.primaryOptions = [];
    this.listAndFields.primary_id = null;
  }

  onNewField() {
    this.selectedField = {} as any;
    this.selectedField.list_resp_type_id = 0;
  }

  onDeleteList() {
    this.listService.deleteList(this.list.id + '').subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewList();
    });
  }

  onDeleteField() {
    this.listService.deleteField(this.selectedField).subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.loadAllFields();
      this.onNewField();
    });
  }

  // Auxiliar Functions

  _responseErrorHandler(r: ReturnMessageModel) {
    if (r.error) this.message.error(r.message);
    else this.message.success(r.message);
  }

  validate(): boolean {
    return DynamicListModel.validate(this.list) && !this.duplicateValidation();
  }

  duplicateValidation() {
    return !this.list.id && this.lists.findIndex((list) => list.name == this.list.name) > -1;
  }

  order() {
		this.lists = _.orderBy(this.lists, this.selectedOrdenation, this.selectedMethod);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");

  loadOrdenation() {
      this.ascDesc = [
      { value: 'asc', label: this.translate('asc') },
      { value: 'desc', label: this.translate('desc') },
    ];

    this.ordenation = [
      { value: 'created_at', label: this.translate('creation_date') },
      { value: 'name', label: this.translate('alph_order') },
      { value: 'list_type', label: this.translate('type') }
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/dynamic-list/dynamic-list.component.ts